let companyTimeZone;
let displayTimeZone;

/**
 * @description
 * TimeZone service stores information about current display timezone and is indispensable when it comes to perform
 * timezone operations on moment objects.
 */
export const bbTimeZone = {

    setDisplay(timeZone) {
        displayTimeZone = timeZone;
    },

    getDisplay() {
        return displayTimeZone;
    },

    getDisplayUTCOffset(datetime) {
        if (datetime) {
            return moment(datetime).tz(displayTimeZone).utcOffset();
        }

        return moment().tz(displayTimeZone).utcOffset();
    },

    /**
     * @param {moment|String} datetime If string must be valid ISO string
     * @returns {moment}
     */
    convertToDisplay(datetime) {
        return displayTimeZone ? moment.tz(datetime, displayTimeZone) : moment(datetime);
    },

    setCompany(timeZone) {
        companyTimeZone = timeZone;
    },

    getCompany() {
        return companyTimeZone;
    },

    getCompanyUTCOffset() {
        return moment().tz(companyTimeZone).utcOffset();
    },

    /**
     * @description Changes
     * @param {moment|String} datetime If string must be valid ISO string
     * @returns {moment}
     */
    convertToCompany(datetime) {
        return companyTimeZone ? moment.tz(datetime, companyTimeZone) : moment(datetime);
    },

    // Format for API usage. Always in company time zone.
    toCompanyDate(datetime) {
        return bbTimeZone.convertToCompany(datetime).format('YYYY-MM-DD');
    },

    // Format in display date when returning data from API.
    toDisplayDate(datetime) {
        return bbTimeZone.convertToDisplay(datetime).format('YYYY-MM-DD');
    }

};
